import { useTranslation } from "react-i18next";

import { useSelector } from "react-redux";

import { useState } from "react";

import { usePageTitle } from "@/utils/usePageTitle";

import { useGetQuestionnaireQuery } from "@/pages/Public/redux/questionnaire/questionnaire.api";
import { questionnaireSelector } from "@/pages/Public/redux/questionnaire/questionnaire.slice";

import EditableQuestionnaireList from "./components/EditableQuestionnaireList";

export default function ManageQuestionnaire() {
	const { isLoading: isLoadingInitialData } = useGetQuestionnaireQuery();
	const { t } = useTranslation();
	const ts = (key: string) => t(`manage-questionnaire.${key}`);
	const questionnaire = useSelector(questionnaireSelector);
	const [editingQuestionnaireId, setEditingQuestionnaireId] = useState(-1);

	usePageTitle(ts("title"));

	return (
		<div className="p-6">
			<EditableQuestionnaireList
				data={questionnaire}
				editingQuestionnaireId={editingQuestionnaireId}
				isLoading={isLoadingInitialData}
				setEditingQuestionnaireId={setEditingQuestionnaireId}
			/>
		</div>
	);
}
